const accessSettings = {

    USER_ROLE_LIST: { name: 'User Role', path: '/user-role-list' },
    ADD_USER_ROLE: { name: 'Add User Role', path: '/create-user-role' },
    UPDATE_USER_ROLE: { name: 'Update User Role', path: '/edit-user-role' },
    DELETE_USER_ROLE: { name: 'Delete User Role', path: '/delete-user-role' },

    USER_TYPE_LIST: { name: 'User Type', path: '/user-type-list' },
    ADD_USER_TYPE: { name: 'Add User Type', path: '/create-user-type' },
    UPDATE_USER_TYPE: { name: 'Update User Type', path: '/edit-user-type' },
    DELETE_USER_TYPE: { name: 'Delete User Type', path: '/delete-user-type' },

    MODULE_LIST: { name: 'Module', path: '/module-list' },
    ADD_MODULE: { name: 'Add Module', path: '/create-module' },
    UPDATE_MODULE: { name: 'Update Module', path: '/edit-module' },
    DELETE_MODULE: { name: 'Delete Module', path: '/delete-module' },

    ACTION_LIST: { name: 'Action', path: '/action-list' },
    ADD_ACTION: { name: 'Add Action', path: '/create-action' },
    UPDATE_ACTION: { name: 'Update Action', path: '/edit-action' },
    DELETE_ACTION: { name: 'Delete Action', path: '/delete-action' },

    PERMISSION: { name: 'Permission', path: '/permission' },

}

export default accessSettings;